import script from "./BottomDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BottomDialog.vue?vue&type=style&index=0&id=bf9920a4&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QIcon,QCardActions,QBtn,QSpace});qInstall(script, 'directives', {ClosePopup});
